export default {
  EBI_818: '818',
  EBI_808: '808'
}
